import React from 'react';
import clsx from 'clsx';

import { FormSubmitHandler } from 'components/Form';
import { ModalProps, Modal } from 'components/Modal';

import styles from 'components/ModalForm.module.scss';
import { CloseButton, CloseButtonVariant } from 'components/CloseButton';
import { MODAL_ID, MODAL_CLOSE_BUTTON_TEST_ID } from 'components/Modal.const';
import { StackedForm } from 'components/StackedForm';

export type ModalFormProps = ModalProps & Readonly<{
  onSubmit: FormSubmitHandler;
  title?: string;
  image?: JSX.Element;
}>;

/***
 * A form that displays in a modal with an optional title and onClose
 */
export const ModalForm: React.FC<ModalFormProps> = ({
  title, image, onSubmit, onClose, className, children, ...props
}) => {

  const hasImage = !!image;

  return (
    <Modal onClose={onClose} className={clsx(styles.modal, { [styles.large] : hasImage }, className)} aria={{ labelledby: MODAL_ID }} {...props}>
      {image}
      <StackedForm title={title} onSubmit={onSubmit} children={children} />
      <CloseButton variant={hasImage ? CloseButtonVariant.LIGHT : CloseButtonVariant.DARK} className={styles.close} onClick={onClose} data-testid={MODAL_CLOSE_BUTTON_TEST_ID} />
    </Modal>
  );
};
